import { render } from "./AuthScreen.vue?vue&type=template&id=307b6de4"
import script from "./AuthScreen.vue?vue&type=script&lang=js"
export * from "./AuthScreen.vue?vue&type=script&lang=js"

import "./AuthScreen.vue?vue&type=style&index=0&id=307b6de4&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__